import React, { useState } from 'react';
import { authAPI } from '../../utils/api';
import './UserProfile.css';

const UserProfile = ({ user, onSignOut }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleSignOut = async () => {
    try {
      await authAPI.signOut();
      onSignOut();
      setShowDropdown(false);
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  const getInitials = (email) => {
    return email.charAt(0).toUpperCase();
  };

  const getDisplayName = (email) => {
    return email.split('@')[0];
  };

  return (
    <div className="user-profile">
      <button 
        className="user-profile-button"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <div className="user-avatar">
          {getInitials(user.email)}
        </div>
        <span className="user-name">{getDisplayName(user.email)}</span>
        <svg 
          className={`dropdown-arrow ${showDropdown ? 'open' : ''}`}
          width="12" 
          height="12" 
          viewBox="0 0 12 12"
        >
          <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="2" fill="none"/>
        </svg>
      </button>

      {showDropdown && (
        <>
          <div 
            className="dropdown-overlay" 
            onClick={() => setShowDropdown(false)}
          />
          <div className="user-dropdown">
            <div className="user-info">
              <div className="user-email">{user.email}</div>
              <div className="user-status">Signed in</div>
            </div>
            <hr className="dropdown-divider" />
            <button 
              className="dropdown-item sign-out"
              onClick={handleSignOut}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                <path d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"/>
                <path d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
              </svg>
              Sign Out
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default UserProfile;